import type { DashboardRowType } from '@shared/types/Dashboard';

export const profileEvalPageDashboardRows: DashboardRowType[] = [
  {
    items: [
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 1,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 0,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 2,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 3,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 4,
      },
    ],
  },
  {
    items: [
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 7,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 5,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 8,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 6,
      },
    ],
  },
  {
    items: [
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 9,
      },
    ],
  },
];
